export const swiperOptionsVertical = {
    direction: "vertical",
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesProgress: true,
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
    },
    mousewheel: {
        forceToAxis: true,
    },
};

export const alternateVerticalSwiperOptions = {
    direction: "vertical",
    reverseDirection: true,
    disableOnInteraction: false,
    centeredSlides: true,
    slidesPerView: "auto",
    freeMode: {
        enabled: true,
        sticky: true,
    },
    resistance: true,
    resistanceRatio: 0.8,
    watchOverflow: false,
};

export const coverflowSwiperOptions = {
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 1.25,
    spaceBetween: 72,
    slideToClickedSlide: true,
    coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 1,
        slideShadows: false,
    },
    breakpoints: {
        0: {
            slidesPerView: 1.3,
        },
        540: {
            slidesPerView: 1.5,
        },
        768: {
            slidesPerView: 2,
        },
        1007: {
            slidesPerView: 3,
        },
        1250: {
            slidesPerView: 4,
        },
        1724: {
            slidesPerView: 4,
        },
        1920: {
            slidesPerView: 4.5,
        },
    },
    pagination: {
        el: ".swiper-pagination",
    },
};

const swiperOptions = {
    /**
     * Parse data-attributes from a slider element into slider configuration options.
     *
     * @param {HTMLElement} slider - The slider DOM element to read attributes from.
     * @returns {{ perView: string | number, gap: number, centerSlides: string | null, centerSlidesBounds: string | null, breakpoints: any, initialSlide: number, focusCenter: string | null, loop: string | null, autoplay: string | null, autoplayDelay: number }} The parsed slider options.
     */
    getSliderOptions(slider) {
        return {
            perView:
                slider.getAttribute("data-per-view") === "auto"
                    ? "auto"
                    : parseInt(slider.getAttribute("data-per-view") ?? "1") ||
                      1,
            gap: parseInt(slider.getAttribute("data-gap") ?? "24") || 24,
            centerSlides: slider.getAttribute("data-center-slides"),
            centerSlidesBounds: slider.getAttribute("data-center-bounds"),
            breakpoints: JSON.parse(
                slider.getAttribute("data-breakpoints") || "[]",
            ),
            initialSlide:
                parseInt(slider.getAttribute("data-initial-slide") ?? "0") || 0,
            focusCenter: slider.getAttribute("data-focus-center"),
            loop: slider.getAttribute("data-loop"),
            autoplay: slider.getAttribute("data-autoplay"),
            autoplayDelay:
                parseInt(
                    slider.getAttribute("data-autoplay-delay") ?? "10000",
                ) || 10000,
        };
    },
    /**
     * Parse data-attributes from a slider element into scroll configuration options.
     *
     * @param {HTMLElement} slider - The slider DOM element to read attributes from.
     * @returns {{ centerSlides: string | null, initialSlide: string | null }} The parsed scroll options.
     */
    getScrollOptions(slider) {
        return {
            centerSlides: slider.getAttribute("data-center-slides"),
            initialSlide: slider.getAttribute("data-initial-slide"),
        };
    },
};

window.swiperOptions = swiperOptions;

export default swiperOptions;
